import { EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation } from "@relay/deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation.graphql";
import { DELETE_PERSONALIZED_EMAIL_TEMPLATE_MUTATION } from "./delete-email-template-button.graphql";
import { type DeleteEmailTemplateButtonProps } from "./delete-email-template-button.types";
import { Button, ButtonVariant } from "../../../../components/button";
import { useDialogLogic } from "../../../../hooks/use-dialog-logic/use-dialog-logic.hook";

export const DeleteEmailTemplateButton = ({
	personalizedEmailTemplateId,
	connectionId,
}: DeleteEmailTemplateButtonProps) => {
	const { t } = useTranslation("common");
	const { showDialog, dialogComponent } = useDialogLogic();
	const [deletePersonalizedEmailTemplate, isDeletingPersonalizedEmailTemplate] =
		useMutation<deleteEmailTemplateButton_DeletePersonalizedEmailTemplateMutation>(
			DELETE_PERSONALIZED_EMAIL_TEMPLATE_MUTATION,
		);
	const handleOnDeleteClick = () => {
		showDialog({
			title: t("emailTemplates.deleteTitle"),
			content: t("emailTemplates.deleteConfirm"),
			dialogCallback: (result) => {
				if (result === "Accept") {
					deletePersonalizedEmailTemplate({
						variables: {
							input: {
								ids: [personalizedEmailTemplateId],
							},
							connections: [connectionId],
						},
					});
				}
			},
		});
	};

	return (
		<>
			{dialogComponent}
			<Button
				disabled={isDeletingPersonalizedEmailTemplate}
				icon={EpicIcons.TRASH}
				variant={ButtonVariant.Error}
				onClick={handleOnDeleteClick}
			/>
		</>
	);
};
